import { render, staticRenderFns } from "./EventManage.vue?vue&type=template&id=5b310bde&"
import script from "./EventManage.vue?vue&type=script&lang=js&"
export * from "./EventManage.vue?vue&type=script&lang=js&"
import style0 from "./EventManage.vue?vue&type=style&index=0&id=5b310bde&lang=scss&"
import style1 from "./EventManage.vue?vue&type=style&index=1&id=5b310bde&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b310bde')) {
      api.createRecord('5b310bde', component.options)
    } else {
      api.reload('5b310bde', component.options)
    }
    module.hot.accept("./EventManage.vue?vue&type=template&id=5b310bde&", function () {
      api.rerender('5b310bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/others/event-manage/EventManage.vue"
export default component.exports